/**
 * Post ajax grid for WordPress
 * Required isotope + jquery
 * Backend API at app/custom/ajax/grid_ajax.php
 * @example
 * new PostGrid({
 *       grid: '.js-grid-content',
 *       tag_type: 'acf',
 *       wide_elements: true
 *   });
 *
 * @author Alexander Holovko <holovko.works@gmail.com>
 */

import * as Isotope from "../../libs/isotope/isotope.pkgd.min";
import make_uppercase from "../make_uppercase"
import ringoPhoneMutations from '../ringo-phone-mutations';

class PostGrid {

    constructor(options) {

        const defaults = {
            grid: '.js-grid-content',
            grid_wrapper: '.js-grid',
            post_type: 'news',
            tag_type: 'tag',
            tags: '.js-tag',
            item: '.js-ajax-new',
            rearrange_on_click: false,
            tag_all: {class_selector: '.tag-all', class_name: 'tag-all'},
            pagination: '.js-pagination',
            search: '.js-search',
            sort: '.js-sort-select',
            acf_tags_key: 'news_type',
            taxonomy_name: 'taxonomy_name',
            wide_elements: false,
            gutter: 8,
            apply_filters_button: '.js-apply-filters',
            reset_filters_button: '.js-reset-filters',
            catalog_mobile_bar: '.js-catalog-mobile-bar',
            selected_filters_el: '.js-selected-filters-list',
            collapse_filter: '[data-trigger="collapse-filter"]',
            tag_display: 'tab',  /*Available: tab, select*/
            post_count: 8,
            catalog: false,
            models: false,
            selection: 'multiple', /*Available: singular, multiple*/
            multiple_relation: 'or', /*Available: or, and*/
            nearest_showrooms: '.js-show-nearest-showrooms',
            group_by_taxonomy: 0,
            masonry: true
        };

        options = Object.assign(defaults, options);

        $(document).find('.nice-select').removeClass('js-tag');

        this.options = options;
        this.const_post_count = this.options.post_count;
        this.item = options.item;
        this.post_type = options.post_type;
        this.grid = $(options.grid);
        this.grid_wrapper = $(options.grid_wrapper);
        this.pagination = $(options.pagination);
        this.tags = $(options.tags);
        this.tag_all = this.grid_wrapper.find(options.tag_all.class_selector);
        this.search = $(options.search);
        this.sort = $(options.sort);
        this.ajax_item = $(this.item).eq(0).clone();
        this.is_catalog_root = (window.location.pathname.endsWith('/catalog/') || window.location.pathname.endsWith('/catalog'));

        this.make(options.grid);
        this.search_call('grid_search');
        this.pagination_call('grid_pagination');
        this.sort_call('grid_sort');
        this.show_nearest_showrooms('grid_sort');
        this.child_tags();

        if (options.catalog && this.is_catalog_root) {
            // this.get_catalog_state();
        } else if (options.catalog && !this.is_catalog_root) {
            this.create_ajax_from_url();
        }

        if (options.models) {
            this.get_models_state();
        }

        if (this.options.selection === 'singular') {
            this.tax_relation = 'AND';
        } else {
            this.tax_relation = 'OR';
        }

        if (this.options.catalog) {
            this.tags_catalog('grid_filter');
        } else {
            this.tags_call('grid_filter');
        }
    }

    make(grid) {

        if (this.options.masonry) {
            this.iso = new Isotope(grid, {
                transitionDuration: 0,
                masonry: {
                    columnWidth: '.grid-item',
                    gutter: this.options.gutter
                }
            });

            $('.grid-item').addClass('no-transition');

            if (this.options.rearrange_on_click) {
                const rearrange_items = $(this.options.rearrange_on_click);
                rearrange_items.on('click', () => {
                    this.iso.layout();
                })
            }
        } else {
            this.grid.addClass('no-masonry');
        }

    }

    tags_call(action) {

        let object = this;

        /*tab display tags*/
        if (object.options.tag_display === 'tab') {
            object.tags.on('click', function () {

                let data = [];
                let sort = object.sort.val();

                let $this = $(this);

                /*set post count to initial option value*/
                object.options.post_count = object.options.const_post_count;


                /*if clicked "ALL" tag*/
                if ($this.hasClass(object.options.tag_all.class_name)) {

                    $this.parent().find(object.tags).removeClass('selected');
                    $this.addClass('selected');
                    data = 'all';

                } else {

                    /*if we need a few items to select with relation "and"*/
                    if (object.options.selection === 'multiple') {

                        $this.toggleClass('selected');

                    }
                    /*if we need only one item to select posts from it value*/
                    else if (object.options.selection === 'singular') {

                        object.grid_wrapper.find(object.tags).removeClass('selected');
                        $this.toggleClass('selected');

                        if (typeof $this.parent().data('parent') !== "undefined") {
                            object.grid_wrapper.find('[data-tag="' + $this.parent().data('parent') + '"]').addClass('selected');

                            /*Show all items if this is show rooms and selected a city*/
                            if (object.options.post_type === 'show-rooms') {
                                object.options.post_count = -1;
                            }
                        }

                    }

                    /*Remove "ALL" tag selected class*/
                    if (object.tag_all.hasClass('selected')) {
                        object.tag_all.removeClass('selected')
                    }
                }


                /*If no tags selected*/
                if (object.tags.parent().find('.selected').length === 0) {

                    object.tag_all.addClass('selected');
                    data = 'all';

                }
                /*If "ALL" tag is not selected*/
                else if (!object.tags.parent().find('.selected').hasClass(object.options.tag_all.class_name)) {

                    object.tags.parent().find('.selected').each(function () {
                        if (typeof $(this).data('tag') !== 'undefined') {
                            data.push($(this).data('tag'));
                        }
                    })
                }


                object.ajax_call({
                    action: action,
                    data_tags: data,
                    sort: sort
                });

            });
        } else if (object.options.tag_display === 'select') {

            object.tags.on('change', function () {
                let $this = $(this);
                let data = [];

                let sort = object.sort.val();

                $this.addClass('selected');

                data.push($this.val());

                object.ajax_call({
                    action: action,
                    data_tags: data,
                    sort: sort
                });
            })
        }

    }

    tags_catalog(action) {
        let object = this;

        object.tags.on('click', function () {
            let data = [];
            let sort = object.sort.val();
            const $filter_parent = $('.js-filter-parent');
            const $filter_child = $('.js-filter-child');
            let $this = $(this);
            const $filter_top_wrap = $this.parents('.js-top-filter-parent');

            /*If clicked "ALL" tag*/
            if ($this.hasClass(object.options.tag_all.class_name)) {

                $filter_top_wrap.find('.js-filter-child').find(object.tags).removeClass('selected');

                $filter_top_wrap.find('.js-filter-child').find('select').val('none');

                object.refresh_nice_select();

            } else {

                /*if parent-filter was clicked*/
                if ($this.hasClass('js-filter-parent')) {

                    $filter_parent.removeClass('selected');
                    $filter_child.find('.js-tag').removeClass('selected');

                    $filter_top_wrap.find('.js-filter-child').find('select').val('none');
                    object.refresh_nice_select();

                    $this.addClass('selected');

                }

                /*if child-filter was clicked*/
                else if ($this.parents('.js-filter-child').length > 0) {

                    /*define parent of clicked child-filter*/
                    let this_parent = $filter_top_wrap.find('[data-tag="' + $this.parents('.js-filter-child').data("parent") + '"]');

                    /*define parent filters except parent of current child-filter*/
                    let other_parents = $filter_top_wrap.find('.js-filter-parent:not([data-tag="' + $this.parents('.js-filter-child').data("parent") + '"])');

                    /*define child filters of other parents*/
                    let other_child_tags = other_parents.parent().find('.js-filter-child .js-tag');

                    /*reset other tags*/
                    $filter_parent.removeClass('selected');
                    other_child_tags.removeClass('selected');

                    /*add selected*/
                    if (!this_parent.hasClass('selected')) {
                        this_parent.addClass('selected');
                        $this.toggleClass('selected')
                    }

                }

                /*other tag clicked*/
                else {
                    $this.toggleClass('selected');
                }

                /*remove tag-all selection because other tag is clicked*/
                if (object.tag_all.hasClass('selected')) {
                    object.tag_all.removeClass('selected')
                }
            }

            /*if no tags selected*/
            if (object.tags.parent().find('.selected').length === 0) {

                object.tag_all.addClass('selected');
                data = 'all';

            }

            /*if selected some tags (no "ALL" tag)*/
            else if (!object.tags.parent().find('.selected').hasClass(object.options.tag_all.class_name)) {

                let selected = object.tags.parent().find('.js-tag.selected');

                selected.each(function () {

                    if ($(this)[0].nodeName !== 'SELECT') {
                        if (typeof $(this).data('tag') !== 'undefined') {
                            data.push($(this).data('tag'));
                        }
                    } else {
                        data.push($(this).val());
                    }
                });

            }

            if ($(window).width() > 576) {
                object.ajax_call({
                    action: action,
                    data_tags: data,
                    sort: sort,
                    redirect: true
                });
            } else {
                $(object.options.catalog_mobile_bar).addClass('active');
            }
        });


        object.tags.on('change', function () {
            let data = [];
            let sort = object.sort.val();
            let $this = $(this);
            const $filter_parent = $('.js-filter-parent');
            const $filter_child = $('.js-filter-child');
            const $filter_top_wrap = $this.parents('.js-top-filter-parent');


            /*if parent-filter was changed*/
            if ($this.hasClass('js-filter-parent')) {

                $filter_parent.removeClass('selected');
                $filter_child.find('.js-tag').removeClass('selected');
                $this.addClass('selected');

            }

            /*if child-filter was changed*/
            else if ($this.parents('.js-filter-child').length > 0) {

                /*define parent of clicked child-filter*/
                let this_parent = $filter_top_wrap.find('[data-tag="' + $this.parents('.js-filter-child').data("parent") + '"]');

                /*define parent filters except parent of current child-filter*/
                let other_parents = $filter_top_wrap.find('.js-filter-parent:not([data-tag="' + $this.parents('.js-filter-child').data("parent") + '"])');

                /*define child filters of other parents*/
                let other_child_tags = other_parents.parent().find('.js-filter-child .js-tag');

                /*reset other tags*/
                $filter_parent.removeClass('selected');
                other_child_tags.removeClass('selected');

                /*add selected*/
                if (!this_parent.hasClass('selected')) {
                    this_parent.addClass('selected');
                }

                $this.addClass('selected')

            }

            /*other tag clicked*/
            else {
                $this.addClass('selected');
            }

            /*remove tag-all selection because other tag is clicked*/
            if (object.tag_all.hasClass('selected')) {
                object.tag_all.removeClass('selected')
            }

            /*if no tags selected*/
            if (object.tags.parent().find('.selected').length === 0) {

                object.tag_all.addClass('selected');
                data = 'all';

            }

            /*if selected some tags (no "ALL" tag)*/
            else if (!object.tags.parent().find('.selected').hasClass(object.options.tag_all.class_name)) {

                let selected = object.tags.parent().find('.js-tag.selected');

                selected.each(function () {

                    if (typeof $(this).data('tag') !== 'undefined') {
                        data.push($(this).data('tag'));
                    }

                });

            }

            /*if it is select push it value*/
            if ($this.hasClass('js-styled-select')) {
                data.push($this.val());
            }

            /*call ajax*/
            if ($(window).width() > 576) {
                object.ajax_call({
                    action: action,
                    data_tags: data,
                    sort: sort,
                    redirect: true
                });
            } else {
                $(object.options.catalog_mobile_bar).addClass('active');
            }
        });

        if ($(window).width() < 576) {
            object.catalog_mobile(action);
        }

    }

    catalog_mobile(action) {

        let object = this;

        $(object.options.apply_filters_button).on('click', function () {

            let data = [];
            let sort = object.sort.val();

            $(object.options.selected_filters_el).children().remove();

            /*If clicked "ALL" tag*/
            if (object.tags.parent().find('.selected').hasClass(object.options.tag_all.class_name)) {
                data = 'all';
            } else {
                object.tags.parent().find('.selected').each(function () {

                    if (typeof $(this).data('tag') !== 'undefined') {
                        data.push($(this).data('tag'));

                        if (typeof $(this).data('name') !== 'undefined') {
                            $(object.options.selected_filters_el)
                                .append('' +
                                    '<div class="selected-filter js-filter-remove" data-remove="' + $(this).data('tag') + '">' +
                                    '' + $(this).data('name') + '<span>&times;</span>' +
                                    '</div>' +
                                    '')
                        }
                    }

                });
            }


            if ($(object.options.selected_filters_el).children().length > 0) {
                $(object.options.selected_filters_el).addClass('active')
            } else {
                $(object.options.selected_filters_el).removeClass('active')
            }

            $(object.options.catalog_mobile_bar).removeClass('active');
            $(object.options.collapse_filter).click();

            object.ajax_call({
                action: action,
                data_tags: data,
                sort: sort,
                redirect: true
            });
        });

        $(object.options.reset_filters_button).on('click', function () {

            $(object.options.selected_filters_el).children().remove();

            const $filter_top_wrap = $('.js-top-filter-parent.is-mobile');

            $filter_top_wrap.find(object.tags).removeClass('selected');
            $filter_top_wrap.find(object.tag_all).addClass('selected');

            let data = 'all';
            let sort = object.sort.val();

            object.ajax_call({
                action: action,
                data_tags: data,
                sort: sort,
                redirect: true
            });

            $(object.options.catalog_mobile_bar).removeClass('active');
        });


        $(document).on('click', '.selected-filter.js-filter-remove', function () {

            let data = [];
            let sort = object.sort.val();
            let filter = object.tags.parent().find('[data-tag="' + $(this).data('remove') + '"');
            filter.removeClass('selected');

            object.tags.parent().find('.selected').each(function () {

                if (typeof $(this).data('tag') !== 'undefined') {
                    data.push($(this).data('tag'));
                }

            });

            object.ajax_call({
                action: action,
                data_tags: data,
                sort: sort,
                redirect: true
            });

            $(this).remove();

            if ($(object.options.selected_filters_el).children().length > 0) {
                $(object.options.selected_filters_el).addClass('active')
            } else {
                $(object.options.selected_filters_el).removeClass('active')
            }
        })


    }


    search_call(action) {

        const $input = this.search.find('.js-search-input');
        const $search_button = this.search.find('.js-search-button');
        const $search_icon = this.search.find('.js-search-icon');
        const $search_close = this.search.find('.js-search-close');
        $($input).keyup(function() {
            let value = $( this ).val();
            if(!value.length) {
                $search_close.css('display', 'none')
            } else {
                $search_close.css('display', 'block')
            }
            console.log('value.length', value.length)
            // $( "p" ).text( value );
        }).keyup();

        $search_close.on('click', (e) => {
            e.preventDefault();
            $search_close.css('display', 'none')
            $('.js-search-input').val('')
            this.run_search($input, action);
        });

        $search_button.on('click', (e) => {
            e.preventDefault();
            this.run_search($input, action);
        });

        $search_icon.on('click', (e) => {
            e.preventDefault();
            this.run_search($input, action);
        });

        $input.on('keyup', (e) => {

            if (e.keyCode === 13 || e.which === 13) {
                this.run_search($input, action);
            }
        });
    }

    run_search($input, action) {

        let object = this;

        let ths = $input;

        object.search.find('.js-search-alert').remove();

        let search_value = ths.val().trim();

        let data_page = $(this).data('page');
        let data_tags = [];

        if (typeof this.tags !== 'undefined') {
            object.tags.removeClass('selected');
            object.tags.parent().find('.js-all-tags').click();
        }

        if (object.tag_all.hasClass('selected')) {
            data_tags = 'all';
            console.log('tag-all selected');
        } else {
            object.tags.parent().find('.selected').each(function () {

                if ($(this)[0].nodeName !== 'SELECT') {
                    data_tags.push($(this).data('tag'));
                } else {
                    data_tags.push($(this).val());
                }

            })
        }

        object.ajax_call({
            action: action,
            data_tags: data_tags,
            data_page: data_page,
            search: search_value,
        });

    }

    sort_call(action) {

        let object = this;

        let data_tags = [];

        object.sort.on('change', function () {

            data_tags = [];

            let data_page = object.pagination.find('.active').data('active-page');
            let sort = object.sort.val();

            if (object.tag_all.hasClass('selected')) {
                data_tags = 'all';
                console.log('tag-all selected');
            } else {
                object.tags.parent().find('.selected').each(function () {

                    if ($(this)[0].nodeName !== 'SELECT') {
                        data_tags.push($(this).data('tag'));
                    } else {
                        data_tags.push($(this).val());
                    }

                })
            }

            data_tags = object.unicalize_tags(data_tags);

            object.ajax_call({
                action: action,
                data_tags: data_tags,
                data_page: data_page,
                sort: sort,
            });

        })
    }

    pagination_call(action) {

        let object = this;

        let data_tags = [];

        object.pagination.on('click', '.js-pagination-page', function () {

            data_tags = [];
            let sort = object.sort.val();

            console.log(sort);

            let data_page = $(this).data('page');

            if (object.tag_all.hasClass('selected')) {
                data_tags = 'all';
            } else {
                object.tags.parent().find('.selected').each(function () {

                    if ($(this)[0].nodeName !== 'SELECT') {
                        data_tags.push($(this).data('tag'));
                    } else {
                        data_tags.push($(this).val());
                    }
                })
            }

            console.log(data_tags);

            object.ajax_call({
                action: action,
                data_tags: data_tags,
                data_page: data_page,
                sort: sort,
            })

        })
    }

    ajax_call(data) {
        let object = this;
        let resp = [];

        const $loader = $('.ajax-loader');

        const defaults = {
            action: 'grid_filter',
            data_tags: null,
            data_page: 1,
            sort: '',
            search: ''
        };

        if (object.post_type == 'models' && data.data_tags.includes('all')) {
            data.data_tags = 'all';
        }

        data = Object.assign(defaults, data);

        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'tags': data.data_tags,
                'action': data.action,
                'tag_type': object.options.tag_type,
                'post_type': object.post_type,
                'page': data.data_page,
                'sort': data.sort,
                'tax_relation': object.tax_relation,
                'search': data.search,
                'acf_tags_key': object.options.acf_tags_key,
                'taxonomy_name': object.options.taxonomy_name,
                'post_count': object.options.post_count,
                'group_by_taxonomy': object.options.group_by_taxonomy,
                'latpoint': data.latpoint,
                'longpoint': data.longpoint,
                'url': data.url,
                'multiple_relation': object.options.multiple_relation
            },
            beforeSend: () => {
                $loader.addClass('active');
            },
            success: (response) => {
                if(data.redirect){
                   document.location.href = response.url;
                   return;
                }


                if (typeof response.posts !== "undefined") {
                    if (response.posts.type === 'catalog_all') {
                        object.container_cat_divided_fill(response, object.ajax_item);
                    } else {
                        object.container_fill(response, object.ajax_item);
                    }
                }

                if (object.options.models) {
                    /*Save state to sessionStorage*/
                    // object.save_models_state(data);
                }


                if (object.options.catalog) {
                    /*Save state to sessionStorage*/
                    // object.save_catalog_state(data);

                    // object.set_seo(response.url);

                    object.change_url(response.url, 'Каталог')

                    object.set_language(response.url)
                    // document.location.href = response.url;
                    // console.log(response);
                }


            },

            error: function (jqXHR, exception) {
                let msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connect.\n Verify Network.';
                } else if (jqXHR.status == 404) {
                    msg = 'Requested page not found. [404]';
                } else if (jqXHR.status == 500) {
                    msg = 'Internal Server Error [500].';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Time out error.';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Uncaught Error.\n' + jqXHR.responseText;
                }
                console.log(msg);
            },
            complete: function () {
                $loader.removeClass('active');

                ringoPhoneMutations(object.options.item + ' ' + '.ringo-phone');

                setTimeout(function () {
                    window.bLazy.revalidate();
                }, 50);
            }
        });

        return resp;
    }

    container_fill(response, $ajax_item) {

        let $ajax_link = $ajax_item.find('.js-ajax-link');
        let $ajax_title = $ajax_item.find('.js-ajax-title');
        let $ajax_image = $ajax_item.find('.js-ajax-image');
        let $ajax_image2 = $ajax_item.find('.js-ajax-image2');
        let $ajax_time = $ajax_item.find('.js-ajax-time');
        let $ajax_type = $ajax_item.find('.js-ajax-type');
        let $ajax_city = $ajax_item.find('.js-ajax-city');
        let $ajax_address = $ajax_item.find('.js-ajax-address');
        let $ajax_phone_wrap = $ajax_item.find('.js-ajax-phone-wrap');
        let $ajax_phone = $ajax_item.find('.js-ajax-phone').eq(0);
        let $ajax_work_time = $ajax_item.find('.js-ajax-work-time');
        let $ajax_previews = $ajax_item.find('.js-ajax-previews');
        let $ajax_price = $ajax_item.find('.js-ajax-price');
        let $ajax_old_price = $ajax_item.find('.js-old-price');
        let $ajax_product_hover = $ajax_item.find('.js-ajax-image-hover');
        let $ajax_product_desc = $ajax_item.find('.js-ajax-desc');
        let $ajax_has_3d = $ajax_item.find('.js-has-3d');
        let object = this;

        if (object.options.masonry) {
            object.iso.remove(object.grid.children());
        } else {
            object.grid.children().remove();
        }

        object.pagination.children('.pagination').remove();
        $('.search-no-results').remove();

        let items_collection = $([]);

        if (response.posts.length > 0) {

            response.posts.forEach((item, index) => {

                $ajax_link.attr('href', item.link);

                if ($ajax_item[0].nodeName === 'A') {
                    $ajax_item.attr('href', item.link);
                }

                $ajax_title.text(item.title);

                if ($ajax_image.find('img').length > 0) {
                    if (item.image) {
                        $ajax_image.find('img').attr('data-src', item.image);
                        $ajax_image.find('img').attr('src', item.image);
                        $ajax_image.find('img').attr('alt', item.title);
                    }
                } else {
                    $ajax_image.css('background-image', 'url(' + item.image + ')');
                }

                if ($ajax_product_hover.length > 0) {
                    if (item.product_hover) {
                        $ajax_product_hover.attr('data-src', item.product_hover).show();
                        $ajax_product_hover.attr('src', item.product_hover);
                        $ajax_image2.show().find('img').attr('data-src', item.product_hover);
                        $ajax_previews.removeClass('product-card__images--only-one');
                        $ajax_image.removeClass('product-card__images--only-one');
                    } else {
                        $ajax_product_hover.hide();
                        $ajax_image2.hide();
                        $ajax_previews.addClass('product-card__images--only-one');
                    }
                }

                $ajax_time.text(item.time);

                if ($ajax_type.length > 0) {
                    $ajax_type.text(item.type);
                }

                

                if(item.sale_price && false){
                    if ($ajax_price.length > 0) {
                        $ajax_price.text(item.sale_price);
                    }
                    if ($ajax_old_price.length > 0) {
                        $ajax_old_price.text(item.price);
                    }
                } else {
                    if ($ajax_price.length > 0) {
                        $ajax_price.text(item.price);
                    }
                }

                if ($ajax_product_desc.length > 0) {
                    $ajax_product_desc.html(item.product_desc);
                }

                if (item.max_width !== '') {
                    $ajax_previews.css({
                        'max-width': item.max_width + 'px'
                    })
                } else {
                    $ajax_previews.css({
                        'max-width': 'initial'
                    })
                }

                if (item.max_percent !== '') {
                    $ajax_previews.css({
                        'width': item.max_percent + '%'
                    })
                } else {
                    $ajax_previews.css({
                        'width': '100%'
                    })
                }

                if (item.post_type === 'show-rooms') {

                    $ajax_city.text(item.city);
                    $ajax_address.text(item.address);
                    $ajax_phone_wrap.children().remove();


                    if (item.has_ringo_phone) {
                        //замена телефонов на ringo-phone
                        let $ajax_phone_append = $ajax_phone.clone();
                        $ajax_phone_append.text($('.header__phone').html());
                        $ajax_phone_wrap.append($ajax_phone_append);
                    } else {
                        if (item.phones) {
                            console.log('no-ringo');

                            item.phones.forEach(function (el) {
                                let $ajax_phone_append = $ajax_phone.clone();
                                $ajax_phone_append.text(el.tel).removeClass('ringo-phone');
                                $ajax_phone_wrap.append($ajax_phone_append)
                            });
                        }
                    }

                    $ajax_phone.text();
                    $ajax_work_time.text(item.work_time);

                    if (item.has_3d) {
                        $ajax_has_3d.css('display', 'block');
                    } else {
                        $ajax_has_3d.css('display', 'none');
                    }
                }

                let $ajax_item_clone = $ajax_item.clone();
                $ajax_item_clone.attr('data-product-id', item.post_id);
                $ajax_item_clone.attr('data-product-categories', item.post_categories);

                if (object.options.wide_elements) {
                    if (index === 3) {
                        $ajax_item_clone.addClass('width-2')
                    }
                }

                $ajax_item_clone.find('.b-lazy, .b-lazy-wrapper').removeClass('b-lazy-wrapper').removeClass('b-lazy')

                items_collection = items_collection.add($ajax_item_clone);

            });

            object.grid.append(items_collection);

            if (object.options.masonry) {
                object.iso.appended(items_collection);
                object.iso.layout();
            }

            make_uppercase();

            object.pagination.append(response.pagination);
        } else {
            object.grid.append('<div class="search-no-results">По вашему запросу ничего не найдено</div>')
        }
    }

    container_cat_divided_fill(response, $ajax_item) {

        let $ajax_link = $ajax_item.find('.js-ajax-link');
        let $ajax_title = $ajax_item.find('.js-ajax-title');
        let $ajax_image = $ajax_item.find('.js-ajax-image');
        let $ajax_image2 = $ajax_item.find('.js-ajax-image2');
        let $ajax_time = $ajax_item.find('.js-ajax-time');
        let $ajax_type = $ajax_item.find('.js-ajax-type');
        let $ajax_city = $ajax_item.find('.js-ajax-city');
        let $ajax_address = $ajax_item.find('.js-ajax-address');
        let $ajax_phone_wrap = $ajax_item.find('.js-ajax-phone-wrap');
        let $ajax_phone = $ajax_item.find('.js-ajax-phone').eq(0);
        let $ajax_work_time = $ajax_item.find('.js-ajax-work-time');
        let $ajax_previews = $ajax_item.find('.js-ajax-previews');
        let $ajax_price = $ajax_item.find('.js-ajax-price');
        let $ajax_product_hover = $ajax_item.find('.js-ajax-image-hover');
        let $ajax_product_desc = $ajax_item.find('.js-ajax-desc');
        let object = this;

        if (object.options.masonry) {
            object.iso.remove(object.grid.children());
        } else {
            object.grid.children().remove();
        }

        object.pagination.children('.pagination').remove();
        $('.search-no-results').remove();

        if (response.posts.catalog.length > 0) {

            response.posts.catalog.forEach((item_cat, index) => {

                let items_collection = $([]);

                if (index > 0) {
                    object.grid.append('<div class="col-12 grid-divider">' + item_cat.cat_name + '</div>');
                }

                item_cat.products.forEach((item, index) => {

                    $ajax_link.attr('href', item.link);

                    if ($ajax_item[0].nodeName === 'A') {
                        $ajax_item.attr('href', item.link);
                    }

                    $ajax_title.text(item.title);

                    if ($ajax_image.find('img').length > 0) {
                        if (item.image) {
                            $ajax_image.find('img').attr('data-src', item.image);
                            $ajax_image.find('img').attr('src', item.image);
                            $ajax_image.find('img').attr('alt', item.title);
                        }
                    } else {
                        $ajax_image.css('background-image', 'url(' + item.image + ')');
                    }

                    if ($ajax_product_hover.length > 0) {
                        if (item.product_hover) {
                            $ajax_product_hover.attr('data-src', item.product_hover).show();
                            $ajax_product_hover.attr('src', item.product_hover);
                            $ajax_image2.show().find('img').attr('data-src', item.product_hover);
                            $ajax_previews.removeClass('product-card__images--only-one');
                            $ajax_image.removeClass('product-card__images--only-one');
                        } else {
                            $ajax_product_hover.hide();
                            $ajax_image2.hide();
                            $ajax_previews.addClass('product-card__images--only-one');
                        }
                    }

                    $ajax_time.text(item.time);

                    if ($ajax_type.length > 0) {
                        $ajax_type.text(item.type);
                    }

                    if ($ajax_price.length > 0) {
                        $ajax_price.text(item.price);
                    }

                    if ($ajax_product_desc.length > 0) {
                        $ajax_product_desc.html(item.product_desc);
                    }

                    if (item.max_width !== '') {
                        $ajax_previews.css({
                            'max-width': item.max_width + 'px'
                        })
                    } else {
                        $ajax_previews.css({
                            'max-width': 'initial'
                        })
                    }

                    if (item.max_percent !== '') {
                        $ajax_previews.css({
                            'width': item.max_percent + '%'
                        })
                    } else {
                        $ajax_previews.css({
                            'width': '100%'
                        })
                    }

                    if (item.post_type === 'show-rooms') {

                        $ajax_city.text(item.city);
                        $ajax_address.text(item.address);
                        $ajax_phone_wrap.children().remove();

                        //замена телефонов на ringo-phone
                        let $ajax_phone_append = $ajax_phone.clone();
                        $ajax_phone_append.text($('.header__phone').html());
                        $ajax_phone_wrap.append($ajax_phone_append);

                        $ajax_phone.text();
                        $ajax_work_time.text(item.work_time);
                    }


                    let $ajax_item_clone = $ajax_item.clone();

                    if (object.options.wide_elements) {
                        if (index === 3) {
                            $ajax_item_clone.addClass('width-2')
                        }
                    }

                    $ajax_item_clone.find('.b-lazy, .b-lazy-wrapper').removeClass('b-lazy-wrapper').removeClass('b-lazy');

                    items_collection = items_collection.add($ajax_item_clone);
                });

                object.grid.append(items_collection);

            });

            object.pagination.append(response.pagination);
        } else {
            object.grid.append('<div class="search-no-results">По вашему запросу ничего не найдено</div>')
        }
    }

    save_catalog_state(data) {

        sessionStorage.removeItem("catalog");
        sessionStorage.setItem("catalog", JSON.stringify(data));

    }

    get_catalog_state() {

        let data = JSON.parse(sessionStorage.getItem("catalog"));
        let object = this;

        console.log('catalog state: ');
        console.log(data);

        if (data) {

            /*Process tags & selects*/
            if (data.data_tags !== 'all') {

                object.tag_all.removeClass('selected');

                if (typeof data.data_tags !== "undefined") {

                    data.data_tags.forEach(function (el) {

                        let $el_no_select = $(document).find('[data-tag="' + el + '"]');
                        let $el_select = $(document).find('[value="' + el + '"]').parent();

                        $el_no_select.addClass('selected');
                        $el_select.val(el);

                        if ($el_no_select.hasClass('js-filter-parent')) {
                            let data_parent = $el_no_select.data('tag');
                            $('[data-parent="' + data_parent + '"]').show();
                        }

                        object.tag_all.show();
                        object.refresh_nice_select();
                    })

                }

                object.ajax_call(data);
            }
        }
    }

    save_models_state(data) {

        sessionStorage.removeItem("models");
        // sessionStorage.setItem("models", JSON.stringify(data));

    }

    get_models_state() {

        let data = JSON.parse(sessionStorage.getItem("models"));
        let object = this;

        if (data) {

            console.log(data.data_tags);

            if (data.data_tags !== 'all') {
                data.data_tags = data.data_tags.filter(function (el) {
                    return el != null;
                });

                if (data.data_tags.length === 0) {
                    data.data_tags = 'all';
                }
            }

            /*Process tags & selects*/
            if (data.data_tags !== 'all') {

                data.data_tags.forEach(function (el) {
                    let $el_select = $(document).find('[value="' + el + '"]').parent();
                    $el_select.val(el);
                });

            }

            object.ajax_call(data);

            object.refresh_nice_select();
        }
    }

    refresh_nice_select() {
        const $catalog = $('.catalog');

        $('.js-styled-select').niceSelect('update');
        $catalog.find('.nice-select')
            .mouseenter(function () {
                $(this).addClass('open');
            })
            .mouseleave(function () {
                $(this).removeClass('open');
            });
    }

    /*Additional methods for custom pages*/
    child_tags() {
        let object = this;
        let child_tag_containers = $('.js-child-tags-container');

        if (child_tag_containers.length > 0) {
            object.tags.on('click', function () {
                let $this = $(this);

                if (typeof $this.parent().data('parent') === "undefined") {
                    child_tag_containers.removeClass('active');
                    $('.js-child-tags-container[data-show-for="' + $this.data('tag') + '"]').addClass('active');
                } else {
                    child_tag_containers.removeClass('active');
                    $this.parents('.js-child-tags-container').addClass('active');
                }

            })
        }

    }

    show_nearest_showrooms(action) {
        let object = this;

        $('.js-show-nearest-showrooms').on('click', function (e) {

            e.preventDefault();

            let sort = 'nearest';
            let latpoint = 50.450956;
            let longpoint = 30.522603;

            if ("geolocation" in navigator) {
                // check if geolocation is supported/enabled on current browser
                navigator.geolocation.getCurrentPosition(
                    function success(position) {
                        // for when getting location is a success
                        console.log('latitude', position.coords.latitude, 'longitude', position.coords.longitude);

                        latpoint = position.coords.latitude;
                        longpoint = position.coords.longitude;

                        $(object.tags).removeClass('selected');

                        object.ajax_call({
                            action: action,
                            sort: sort,
                            latpoint: latpoint,
                            longpoint: longpoint,
                        });
                    },
                    function error(error_message) {
                        // for when getting location results in an error
                        console.error('An error has occured while retrieving location', error_message);
                    }
                )
            } else {
                // geolocation is not supported
                // get your location some other way
                console.log('geolocation is not enabled on this browser')
            }
        });
    }

    unicalize_tags(data_tags) {

        if (data_tags !== 'all') {
            let unique = [];
            $.each(data_tags, function (i, el) {
                if ($.inArray(el, unique) === -1 && typeof el !== "undefined") {
                    unique.push(el);
                }
            });

            return unique;
        } else {
            return data_tags;
        }


    }

    set_language(response_url) {
        let object = this;
        let lang_cont = $('.dropdown--lang.js-dropdown');
        let links = lang_cont.find('.dropdown__link');

        if (object.options.catalog) {
            links.each(function () {
                let ths = $(this);
                let text = ths.text();

                if (text === 'ru') {
                    ths.attr('href', '/catalog/')
                }
                if (text === 'en') {
                    ths.attr('href', '/en/catalog/')
                }
                if (text === 'uk') {
                    ths.attr('href', '/uk/catalog/')
                }
                if (text === 'ro') {
                    ths.attr('href', '/ro/catalog/')
                }

            })
        }
    }

    change_url(response_url, title = '') {

        let state = {'page_id': 1, 'user_id': 1};

        /*if (title.length > 0) {
            window.history.pushState(state, title, response_url);
        }

        if (this.options.catalog && this.is_catalog_root) {
            window.history.pushState(state, 'Catalog', response_url);
        }*/
    }

    create_ajax_from_url() {

        let object = this;

        let data_tags = [];

        let data_page = object.pagination.find('.active').data('active-page');
        let sort = object.sort.val();

        let url_parts = object.parse_url(window.location.href);

        console.log('url_parts: ');
        console.log(url_parts);

        url_parts.forEach(function (el) {

            let $js_top_filter_parent = $(document).find('.js-top-filter-parent .is-desktop');

            if ($(window).width() < 576) {
                $js_top_filter_parent = $(document).find('.is-mobile.js-top-filter-parent');
            }

            console.log($js_top_filter_parent);

            let $el_no_select = $js_top_filter_parent.find('div[data-slug="' + el + '"], li[data-slug="' + el + '"], span[data-slug="' + el + '"]');
            let $el_option = $js_top_filter_parent.find('option[data-slug="' + el + '"]');
            let $el_select = $el_option.parent();

            console.log('$el_no_select: ' + $el_no_select.length);
            console.log('$el_option: ' + $el_option.length);
            console.log('$el_select: ' + $el_select.length);

            $el_no_select.addClass('selected');
            $el_select.addClass('selected');
            $el_select.val($el_option.attr('value'));

            if ($el_no_select.hasClass('js-filter-parent')) {
                let data_parent = $el_no_select.data('tag');
                $('[data-parent="' + data_parent + '"]').show();
            }

        });

        if (object.tag_all.hasClass('selected') && url_parts === [] && url_parts !== ['en']) {
            data_tags = 'all';
            console.log('tag-all selected');
        } else {

            if (object.tag_all.hasClass('selected')) {
                object.tag_all.removeClass('selected');
            }

            object.tags.parent().find('.selected').each(function () {

                if ($(this)[0].nodeName !== 'SELECT') {
                    data_tags.push($(this).data('tag'));
                } else {
                    data_tags.push($(this).val());
                }
            })
        }

        data_tags = object.unicalize_tags(data_tags);

        console.log('data_tags is: ');
        console.log(data_tags);

        object.ajax_call({
            action: 'url_request',
            data_tags: data_tags,
            data_page: data_page,
            sort: sort,
            url: window.location.href
        });

    }

    parse_url(url) {

        let el = document.createElement('a');
        el.href = url;

        let path = el.pathname;
        let parts = path.split('/');

        let parts_filtered = parts.filter(function (item) {
            return item != null && item !== '' && item !== 'catalog';
        });

        let child_parts = [];

        if (typeof parts_filtered[1] !== "undefined") {
            child_parts = parts_filtered[1].split('_');
        }

        parts_filtered.splice(1, 1);

        let concat = parts_filtered.concat(child_parts);

        let result = concat.filter(function (item) {
            return item != null && item !== '';
        });

        return result;

    }

    set_seo(url) {

        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                'action': 'get_seo',
                'url': url
            },
            beforeSend: () => {

            },
            success: (response) => {

                let description = $(document).find('meta[name=description]');
                let og_description = $(document).find('meta[property="og:description"]');

                console.log(response);
                console.log(description);

                if (typeof response.title !== "undefined" && response.title.length > 0) {

                    description.attr('content', response.description);
                    og_description.attr('content', response.description);

                    document.title = response.title;
                }

            },

            error: function (jqXHR, exception) {
                let msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connect.\n Verify Network.';
                } else if (jqXHR.status == 404) {
                    msg = 'Requested page not found. [404]';
                } else if (jqXHR.status == 500) {
                    msg = 'Internal Server Error [500].';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Time out error.';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Uncaught Error.\n' + jqXHR.responseText;
                }
                console.log(msg);
            },
            complete: function () {

            }
        });

    }
}

export default PostGrid;
